import { z } from 'zod'

import { BookingDiscountAudience, FeeType } from '../constants/pricing'
import { InventoryType } from '../constants/inventory'
import { BookingPaymentType } from '../constants/booking'

export const taxSchema = z.object({
  name: z.string(),
  amount: z.number(), //the fee amount, 0 - 1 if PERCENT, 0+ is FLAT
  value: z.number().default(0).optional(),
  taxable: z.boolean().default(false).optional(),
})

export const feeSchema = z.object({
  name: z.string().min(1),
  amount: z.number().min(0), //the fee amount, 0 - 1 if PERCENT, 0+ is FLAT
  value: z.number().optional().nullable(), //the calculated value of the fee
  type: z.nativeEnum(FeeType),
  taxable: z.boolean().optional().nullable(),
  applyToTypes: z.array(z.nativeEnum(InventoryType)).optional().nullable(),
  applyToProductCategoryIds: z.array(z.string()).optional().nullable(),
})

const discountSchema = z.object({
  name: z.string(),
  value: z.number(), //if type:PERCENT this is a decimal (ex. 0.2 = 20%), if type:FLAT this is a number (ex. 10 = $10)
  amount: z.number().optional(), //optional because we don't set it until we've calculated the discount amount based on the item/order total
  type: z.nativeEnum(BookingDiscountAudience),
})

export const pricingBreakdownSchema = {
  discountValue: z.number().optional(),
  discountAmount: z.number().optional(),
  depositAmount: z.number().optional(),
  subtotal: z.number(),
  subtotalWithoutDiscounts: z.number(),
  tax: z.number(),
  totalTax: z.number(),
  taxPercent: z.number(),
  taxes: z.array(taxSchema).optional(),
  fees: z.array(feeSchema).optional(),
  feeTotal: z.number(),
  tip: z.number(),
  tipPercent: z.number(),
  taxAndTip: z.number(),
  discounts: z.array(discountSchema).optional(),
  discountTotal: z.number(),
  venueFeeTotal: z.number().optional(),
  venueAbsorbedProcessingFeeTotal: z.number().optional(),
  userPaidProcessingFeeTotal: z.number().optional(),
  tablelistFeeTotal: z.number().optional(),
  processingFeeTotal: z.number().optional(),
  price: z.number(),
  total: z.number().optional(),
  totalWithoutDiscounts: z.number().optional(),
  totalWithDiscounts: z.number().optional(),
  totalWithoutFees: z.number().optional(),
  additionalSpend: z.number().default(0),
  venuePayout: z.number().optional(),
}

export const pricingBreakdownResponseSchema = z.object(pricingBreakdownSchema)
